import React, { type ReactNode } from 'react'
import { ProgressBar } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { css } from '@emotion/core'

const tableWidthCss = css`
  width: 170px;
`

const defaultWidthCss = css`
  width: 300px;
`

type Props = {
  percentComplete: number
  label?: ReactNode
  isTableRow?: boolean
}

export default function UploadProgressBar({ percentComplete, label, isTableRow }: Props): JSX.Element {
  const [t] = useTranslation()
  const adjustedPercent = Math.max(1, percentComplete)

  const widthCss = isTableRow ? tableWidthCss : defaultWidthCss

  return (
    <div data-testid="upload-progress-bar" css={widthCss}>
      <ProgressBar
        value={adjustedPercent}
        message={label ?? t('group-management.importing-tree.heading', { percentage: adjustedPercent })}
      />
    </div>
  )
}
